import { isNull } from 'lodash';
import AbstractService from './abstractService';

// Singleton instance
let instance = null;

const _SERVICE_UNAVAILABLE_ = new Error({ message : 'Service Unavailable' });

export default class NonRKPayInvoiceService extends AbstractService {
	static setup(baseURL, options) {
		instance = new NonRKPayInvoiceService(baseURL, options);
	}

	static getInstance() {
		return instance;
	}

	constructor(baseURL, options) {
		super(baseURL, options);
		this.endpoint = 'NonRKPayInvoices';
	}

	static getInvoiceList(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getInvoiceList(...params);
	}

	_getInvoiceList({
		getCancelToken,
		...queryParams
	}) {
		return this.get({
			endpoint    : `${this.endpoint}`,
			queryParams : {
				...queryParams,
				startDate : queryParams.invoiceStartDate,
				endDate   : queryParams.invoiceEndDate,
			},
			getCancelToken,
		});
	}
}
